import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { DomainProvider } from '@/contexts/DomainContext';
import HomePage from '@/pages/HomePage';
import ArticlePage from '@/pages/ArticlePage';
import CategoryPage from '@/pages/CategoryPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import NotFoundPage from '@/pages/NotFoundPage';

const App: React.FC = () => {
  return (
    <Router>
      <DomainProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/:slug" element={<ArticlePage />} />
          <Route path="/categories/:slug" element={<CategoryPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </DomainProvider>
    </Router>
  );
};

export default App; 